/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Detail_Status_Update_FailedInputs */

const en_admin_company_detail_status_update_failed = /** @type {(inputs: Admin_Company_Detail_Status_Update_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to update status.`)
};

const de_admin_company_detail_status_update_failed = /** @type {(inputs: Admin_Company_Detail_Status_Update_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status konnte nicht aktualisiert werden.`)
};

/**
* | output |
* | --- |
* | "Failed to update status." |
*
* @param {Admin_Company_Detail_Status_Update_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_company_detail_status_update_failed = /** @type {((inputs?: Admin_Company_Detail_Status_Update_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Detail_Status_Update_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_company_detail_status_update_failed(inputs)
	return en_admin_company_detail_status_update_failed(inputs)
});